/* eslint-disable react/prop-types */
import React from 'react';
import Helmet from 'react-helmet';
import AuthContext from "./auth/Context";
//import {app_title,app_description,app_logo,app_keywords,app_url,mainColor,facebook_app_id} from "../../config.js";
class Meta extends React.PureComponent{
  render(){
    const {props} = this;
    return (
        <Helmet>
          <meta name="description" content={props.description||this.context.config.app_description}/>
          <meta name="theme-color" content={this.context.config.mainColor} />
          <meta name="apple-mobile-web-app-capable" content="yes"/>
          <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent"/>
  
          <meta property="og:locale" content="vi_VN" />
          <meta property="og:locale:alternate" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={props.fb_title||props.title||this.context.config.app_title} />
          <meta property="og:description" content={props.fb_description || props.description||this.context.config.app_description} />
          <meta property="og:url" content={props.url||this.context.config.app_url||''} />
          <meta property="og:site_name" content={this.context.config.app_title} />
          <meta property="fb:app_id" content={this.context.config.facebook_app_id} />
          <meta property="og:image" content={props.image||this.context.config.app_logo} />
          <meta property="og:image:width" content="600"/>
          <meta property="og:image:height" content="600"/>
  
          <meta name="keywords" content={this.context.config.app_keywords}/>
        </Helmet>
    )
  }
}
Meta.contextType = AuthContext;
export default  Meta;
